module.exports = __webpack_public_path__ + "static/media/innovationKitchen3.9b785512.png";